// A refusal the user caused and can act on. Its message is written for them,
// so uiErrorMessage surfaces it instead of the generic fallback.
export class UserFacingError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'UserFacingError';
    }
}
